import React, {Component} from 'react';

import services from '../../services';

import layouts from '../../layouts';
import Modal from '../Modal';
import Grid from '../Grid';
import Submit from '../Submit';

import Code from './Code';
import Name from './Name';
import AuthType from './AuthType';
import org from '../org';


export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywords: {},
            domain: {
                employeeIds: []
            },
            authVisible: false
        };

        this.domain = {};

        services.employee.onSelect([]);
    }

    componentWillReceiveProps(nextProps) {
        const folderId = nextProps.folderId;

        if(folderId) {
            this.setState({
                keywords: {
                    v: Math.random(),
                    orgId: '',
                    employeeCode: '',
                    realName: '',
                },
                domain: {
                    folderId,
                }
            })
        }
        
    }

    handleSubmit() {
        const data = Object.assign({}, this.state.domain, {employeeIds: services.employee.getSelection()});
        
        this.setState({
            authVisible: true,
            data: data
        })
    }

    handleChange(data) {
        this.setState({
            keywords: Object.assign({}, this.state.keywords, data)
        })
    }

    handleSearchSubmit() {
        this.setState({
            keywords: Object.assign({}, this.state.keywords, {
                v: Date.now(),
                pageNum: 1
            })
        });
    }
    
    handleCancel() {
        this.props.handleCancel();
        this.setState({
            keywords: {
                visible: this.props.visible,
                orgId: '',
                employeeCode: '',
                realName: '',
            },
        })
    }

    handleTypeCancel() {
        this.setState({
            authVisible: false,
        });
        this.handleCancel();
    }

    render() {
        return (
            <Modal title="添加该文件夹授权人" visible={this.props.visible}  handleSubmit={this.handleSubmit.bind(this)} handleCancel={this.handleCancel.bind(this)}>
                <layouts.Search classNames="root-search2" onSubmit={this.handleSearchSubmit.bind(this)}>
                    <div className="root-search-wrapper">
                        <div className="search-item">
                            <org.Name name="orgId" style={{width: 140}} value={this.state.keywords.orgId} handleChange={this.handleChange.bind(this)} />
                            <Code name="employeeCode" style={{width: 140}} value={this.state.keywords.employeeCode} handleChange={this.handleChange.bind(this)} />
                            <Name name="realName" style={{width: 140}} value={this.state.keywords.realName} handleChange={this.handleChange.bind(this)} />
                            <Submit>检索</Submit>
                        </div>
                    </div>
                </layouts.Search>
                <Grid ismodal="true" classNames="root-main2" keywords={this.state.keywords} service={services.employee}  />
                <AuthType visible={this.state.authVisible} data={this.state.data} handleCancel={this.handleTypeCancel.bind(this)} />
            </Modal>
        )
    }
}